"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariantStatusEnum = void 0;
exports.instanceOfVariantStatusEnum = instanceOfVariantStatusEnum;
exports.VariantStatusEnumFromJSON = VariantStatusEnumFromJSON;
exports.VariantStatusEnumFromJSONTyped = VariantStatusEnumFromJSONTyped;
exports.VariantStatusEnumToJSON = VariantStatusEnumToJSON;
exports.VariantStatusEnumToJSONTyped = VariantStatusEnumToJSONTyped;
/**
 * * `N` - New
 * * `D` - Draft
 * * `NR` - Needs Review
 * * `OK` - Ok
 * * `E` - Example
 * * `R` - Restore
 * * `NW` - Not Working
 * @export
 * @enum {string}
 */
var VariantStatusEnum;
(function (VariantStatusEnum) {
    VariantStatusEnum["N"] = "N";
    VariantStatusEnum["D"] = "D";
    VariantStatusEnum["Nr"] = "NR";
    VariantStatusEnum["Ok"] = "OK";
    VariantStatusEnum["E"] = "E";
    VariantStatusEnum["R"] = "R";
    VariantStatusEnum["Nw"] = "NW";
})(VariantStatusEnum || (exports.VariantStatusEnum = VariantStatusEnum = {}));
function instanceOfVariantStatusEnum(value) {
    for (const key in VariantStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(VariantStatusEnum, key)) {
            if (VariantStatusEnum[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function VariantStatusEnumFromJSON(json) {
    return VariantStatusEnumFromJSONTyped(json, false);
}
function VariantStatusEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function VariantStatusEnumToJSON(value) {
    return value;
}
function VariantStatusEnumToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=variantStatusEnum.js.map